<div
    class="home-banner"
    [style.background-image]="backgroundImage | cdnBackground"
    [ngClass]="{ 'home-banner--gradient-overlay': block.data.gradientOverlay }">
    <div class="home-banner__container container" [ngClass]="{ 'home-banner__inner--inverted': block.data.inverted }">
        <!-- Static hero banner option -->
        @if (!block.data.isCarousel) {
            <div class="home-banner__content">
                @if (block.data.heading) {
                    <h1 class="home-banner__heading-primary" [innerHTML]="block.data.heading"></h1>
                }
                @if (block.data.subheading) {
                    <h2 class="home-banner__heading-secondary" [innerHTML]="block.data.subheading"></h2>
                }
                @if (block.data.content) {
                    <p class="home-banner__paragraph" [innerHTML]="block.data.content"></p>
                }
                @if (block.data.link) {
                    <a
                        [routerLink]="block.data.link"
                        [attr.aria-label]="block.data.linkAriaLabel"
                        class="btn btn-primary"
                        [core-analytics]="{ action: block.data.linkText, block }"
                        [innerText]="block.data.linkText"></a>
                }
            </div>
        }

        <!-- Option to use a carousel for content (main hero image is still applied with carousel sitting on top) -->
        @if (block.data.isCarousel) {
            <carousel
                [showIndicators]="block.data.options.dots"
                [noWrap]="!block.data.options.loop"
                [noPause]="!block.data.options.pauseOnHover"
                [isAnimated]="block.data.options.isAnimated"
                [interval]="getInterval()">
                @for (item of block.content; track trackByFn($index, item)) {
                    <slide>
                        <div class="carousel-slide">
                            <div class="carousel-slide__cta">
                                @if (item.data.heading) {
                                    <h2 [innerHTML]="item.data.heading" class="home-banner__heading-primary"></h2>
                                }
                                @if (item.data.content) {
                                    <p [innerHTML]="item.data.content" class="home-banner__paragraph"></p>
                                }
                                @if (item.data.link && !item.data.externalLink) {
                                    <a
                                        [routerLink]="'/' + item.data.link"
                                        [attr.aria-label]="item.data.linkAriaLabel"
                                        class="btn btn-primary"
                                        [core-analytics]="{ action: item.data.link, block }"
                                        [innerHTML]="item.data.linkText"></a>
                                }
                                @if (item.data.link && item.data.externalLink) {
                                    <a
                                        [href]="item.data.link"
                                        [attr.target]="item.data.targetAttr ? '_blank' : '_self'"
                                        [attr.aria-label]="item.data.linkAriaLabel"
                                        class="btn btn-primary"
                                        [core-analytics]="{ action: item.data.externalLink, block }"
                                        [innerHTML]="item.data.linkText"></a>
                                }
                            </div>
                        </div>
                        @if (item.data.image_url) {
                            <img
                                class="carousel-img"
                                [src]="item.data.image_url | cdn"
                                [alt]="item.data.alt_text ? item.data.alt_text : ''" />
                        }
                    </slide>
                }
            </carousel>
        }
    </div>
</div>
